import { render, staticRenderFns } from "./SettingPlan.vue?vue&type=template&id=292c833d&scoped=true&"
import script from "./SettingPlan.vue?vue&type=script&lang=js&"
export * from "./SettingPlan.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlan.vue?vue&type=style&index=0&id=292c833d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292c833d",
  null
  
)

export default component.exports